@if (t.testMode()) {
  <div class="bg-(--surface-inverse) rounded-(--radius-lg) p-(--padding-card) my-(--space-4) w-full overflow-x-auto">
    <pre class="font-mono text-(color:--text-disabled) text-sm whitespace-pre">{{ debugTrace | json }}</pre>
  </div>
}
<form [formGroup]="form" class="p-(--space-3)">
  <div class="flex flex-col gap-(--gap-relaxed)">
    <div class="flex flex-row gap-(--gap-loose)">
      <!-- Nom -->
      <div class="field w-1/2">
        <ces-text-field
          formControlName="name"
          [label]="'common.labels.modelName' | transloco"
          [required]="true"
          [minLength]="3"
          [maxLength]="50"
          [externalErrors]="getExternalErrors('name')" />
      </div>

      <!-- Description -->
      <div class="field w-1/2">
        <ces-text-field formControlName="comment" [label]="'common.labels.description' | transloco" [required]="false" />
      </div>
    </div>

    <!-- Paramètres -->
    <div class="field">
      <label class="block text-label mb-(--space-2)">{{ 'common.labels.parameters' | transloco }}<sup>*</sup></label>
      <ces-parameters-input
        formControlName="parameters"
        [units]="unitOptions"
        [mode]="parameterMode()"
        (parametersChange)="onParametersChange($event)" />
    </div>

    <!-- Expression -->
    <div class="field">
      <label for="expression" class="block text-label mb-(--space-1)">{{ 'common.labels.expression' | transloco }}<sup>*</sup></label>
      <div class="h-64">
        <ces-editor
          formControlName="expression"
          [variables]="editorVariables"
          [autoFormat]="true"
          [showLineNumbers]="true"
          (expressionChange)="onExpressionChange($event)" />
      </div>
      @if (isFieldInvalid('expression')) {
        <small class="text-red-500">
          {{ getErrorMessage('expression') }}
        </small>
      }
    </div>

    @if (errorMessage) {
      <div class="text-red-500 mb-(--space-3)">
        {{ errorMessage }}
      </div>
    }

    <ces-dialog-footer [submitDisabled]="isFormInvalid()" (onSubmit)="onSubmit()" (onCancel)="onCancel()">
      @if (mode === 'edit' && entity) {
        <ces-delete-button
          footer-start
          [label]="'common.buttons.delete' | transloco"
          (confirm)="onDelete()"
          [confirmationConfig]="getDeleteConfirmationConfig()" />
      }
    </ces-dialog-footer>
  </div>
</form>
